import { Lock } from 'lucide-react';

import { AttentionPanel } from '@/features/Attention/AttentionPanel';

/**
 * The trainer's integrity screens, read-only, for the TPO.
 *
 * The same components rather than a parallel set. Two renderings of the same
 * evidence would drift, and the day they disagree the college is reading one
 * story while the trainer acts on another — which is the exact failure this
 * whole feature exists to prevent.
 *
 * Read-only is decided by the server and travels on the payload; nothing here
 * passes a flag in. Every write the panel would offer is hidden, and the API
 * refuses them regardless of what the UI chose to render.
 */
export function IntegrityTab({ batchId }: { batchId: string }) {
  return (
    <div className="space-y-4">
      {/*
        Pinned, not implied. A trainer absorbs "arrived whole is a prompt"
        through daily use; a TPO opening this once a month has to be told, every
        time, in the same words the trainer's own screens use — not softer ones.
      */}
      <div className="flex items-start gap-2.5 rounded-lg border bg-muted/50 px-3 py-2.5 text-xs leading-relaxed text-muted-foreground">
        <Lock className="mt-0.5 h-3.5 w-3.5 flex-none" aria-hidden="true" />
        <p>
          <span className="font-semibold text-foreground">Read-only.</span> These are prompts for
          your trainer to ask about, not findings — most turn out to be nothing. Resolving,
          messaging and re-running checks stay with the trainer who has the conversation.
        </p>
      </div>

      <AttentionPanel batchId={batchId} />
    </div>
  );
}
